import { useCallback, useEffect } from 'react'

import type { FragmentOf } from '~publish/graphql'

import type { SavedReplyItem_SavedReply } from '../SavedReplyItem'

export const useSavedRepliesKeyboardNav = ({
  savedReplies,
  activeIndex,
  setActiveIndex,
  isOpen,
}: {
  savedReplies:
    | FragmentOf<typeof SavedReplyItem_SavedReply>[]
    | undefined
    | null
  activeIndex: number | null
  setActiveIndex: (index: number | null) => void
  isOpen: boolean
}): void => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent): void => {
      // Only handle keyboard navigation when popover is open
      if (!isOpen || !savedReplies?.length) return

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          setActiveIndex(
            activeIndex === null || activeIndex === savedReplies.length - 1
              ? 0
              : activeIndex + 1,
          )
          break
        case 'ArrowUp':
          event.preventDefault()
          setActiveIndex(
            activeIndex === null || activeIndex === 0
              ? savedReplies.length - 1
              : activeIndex - 1,
          )
          break
        case 'Escape':
          event.preventDefault()
          setActiveIndex(null)
          break
        default:
          break
      }
    },
    [savedReplies, activeIndex, setActiveIndex, isOpen],
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return (): void => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}
